<template>
    <v-container class="pa-0">
        <h2 class="mb-2"><TranslatableStringComponent :tstring="{string: 'addFromYourFavoritesOrCarts'}" /></h2>
        <v-expansion-panels focusable>
            <v-expansion-panel class="mb-4">
                <v-expansion-panel-header>
                    <TranslatableStringComponent :tstring="{string: 'yourFavoriteProducts'}" />
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div v-if="!isLoggedIn" class="text-center pt-4">
                        <v-btn
                            :to="
                                getStaticLocalePath({
                                    type: 'page',
                                    slugName: 'login'
                                })
                            "
                            outlined
                            color="primary"
                            ><TranslatableStringComponent :tstring="{string: 'loginToViewFavorites'}" /></v-btn
                        >
                    </div>
                    <div v-else class="pt-4"><ElasticProductResults /></div>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel class="mb-4">
                <v-expansion-panel-header>
                    <TranslatableStringComponent :tstring="{string: 'yourSavedCarts'}" />
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div v-if="!isLoggedIn" class="text-center pt-4">
                        <v-btn
                            :to="
                                getStaticLocalePath({
                                    type: 'page',
                                    slugName: 'login'
                                })
                            "
                            outlined
                            color="primary"
                            >
                            <TranslatableStringComponent :tstring="{string: 'loginToViewSavedCarts'}" />
                        </v-btn
                        >
                    </div>
                    <div v-else><SavedCarts /></div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-container>
</template>
<script>
import handleSnackbar from '~/mixins/handleSnackbar'
import SavedCarts from '~/components/SavedCarts.vue'
import ElasticProductResults from '~/components/ElasticProductResults.vue'
import handleAuth from '~/mixins/handleAuth'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'

export default {
    name: 'BulkOrderPadPersonalization',
    components: { SavedCarts, ElasticProductResults, TranslatableStringComponent, },
    mixins: [handleSnackbar, handleAuth],
    data() {
        return {}
    },
    computed: {},
    methods: {}
}
</script>

<style></style>
